export default __webpack_public_path__ + "static/media/agency2.9294a528.png";